import axios from 'axios'
import {
  OpportunityAllocationInterest,
  OpportunityInterestFormProps,
} from '../lib/types/propsType_v1'
import {
  OPPORTUNITY_ALLOCATION_INTEREST,
  OPPORTUNITY_INTEREST,
  UPLOAD_PUBLIC_FILE,
} from './endpoints'
import { axiosInstance } from '.'

export const opportunityServices = {
  postUploadFiles: async (filesData: File, headers: { [key: string]: string }) => {
    try {
      const formData = new FormData()
      formData.append('file', filesData)
      return await axiosInstance.post(UPLOAD_PUBLIC_FILE, formData, {
        headers: {
          ...headers,
          'Content-Type': 'multipart/form-data',
        },
      })
    } catch (error: any) {
      return error.response
    }
  },

  submitOpportunityInterestForm: (data: OpportunityInterestFormProps, headers = {}) => {
    const formData = new FormData()
    formData.append('name', data.name)
    formData.append('email', data.email)
    formData.append('phone', data.phone)
    formData.append('description', data.description)

    if (data.pitchDeck) {
      formData.append('pitchDeck', data.pitchDeck)
    }

    return axios.post(OPPORTUNITY_INTEREST, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        ...headers,
      },
    })
  },

  getOpportunityAllocationInterest: async (
    opportunityId: number | string,
    headers: { [key: string]: string } = {},
  ) => {
    try {
      const response = await axiosInstance.get<OpportunityAllocationInterest | null>(
        OPPORTUNITY_ALLOCATION_INTEREST(opportunityId),
        { headers },
      )
      return { data: response.data ?? null, status: response.status }
    } catch (error: any) {
      return error.response
    }
  },

  submitOpportunityAllocationInterest: async (
    opportunityId: number | string,
    amountCents: number,
    headers: { [key: string]: string } = {},
  ) => {
    try {
      const response = await axiosInstance.post<OpportunityAllocationInterest>(
        OPPORTUNITY_ALLOCATION_INTEREST(opportunityId),
        { amount: amountCents },
        { headers },
      )
      return { data: response.data, status: response.status }
    } catch (error: any) {
      return error.response
    }
  },

  deleteOpportunityAllocationInterest: async (
    opportunityId: number | string,
    headers: { [key: string]: string } = {},
  ) => {
    try {
      const response = await axiosInstance.delete(OPPORTUNITY_ALLOCATION_INTEREST(opportunityId), {
        headers,
      })
      return { data: response.data, status: response.status }
    } catch (error: any) {
      return error.response
    }
  },
}
